import React, { useState } from "react";

import { Tooltip } from "antd";
import { toast } from "react-toastify";

import styles from "./ClaimCard.module.css";
import { getExplorerBlockUrl, getExplorerTxUrl } from "../utils/explorer";

export const ClaimCard = ({ data, setClaim = false }) => {
  const [isCopied, setIsCopied] = useState(false);

  function copyToClipboard(value) {
    navigator.clipboard
      .writeText(value || "")
      .then(() => {
        setIsCopied(true);

        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((error) => {
        console.error("Failed to copy to clipboard:", error);
        toast.error("Couldn't copy to clipboard");
      });
  }

  const isRemoved = data?.removedAt != null;

  return (
    <div className={`max-[500px]:px-0 border rounded-xl p-6 ${isRemoved ? "bg-[#d9a3a3]" : "bg-[#b39dd4]"} flex flex-col gap-3`}>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <p className="max-[500px]:text-sm">Claim Name</p>
        <div className="flex gap-2 justify-center">
          <p className="max-[500px]:text-xs">{data?.displayName || "N/A"}</p>
        </div>
      </div>
      {!setClaim && isRemoved && data?.addedAt && (
        <div className="flex justify-between max-[500px]:flex-col text-center">
          <p className="max-[500px]:text-sm">Added date</p>
          <div className="flex gap-2 justify-center">
            <p className="max-[500px]:text-xs">
              {new Date(data.addedAt).toLocaleDateString("en-us", {
                weekday: "long",
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </p>
          </div>
        </div>
      )}
      {!setClaim && isRemoved && (
        <div className="flex justify-between max-[500px]:flex-col text-center">
          <p className="max-[500px]:text-sm">Removed date</p>
          <div className="flex gap-2 justify-center">
            <p className="max-[500px]:text-xs">
              {new Date(data.removedAt).toLocaleDateString("en-us", {
                weekday: "long",
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </p>
          </div>
        </div>
      )}
      {!setClaim && !isRemoved && (
        <div className="flex justify-between max-[500px]:flex-col text-center">
          <p className="max-[500px]:text-sm">Issue date</p>
          <div className="flex gap-2 justify-center">
            <p className="max-[500px]:text-xs">
              {data?.updatedAt
                ? new Date(data.updatedAt).toLocaleDateString("en-us", {
                    weekday: "long",
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })
                : "N/A"}
            </p>
          </div>
        </div>
      )}
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <label htmlFor={`blockHash-${data.id}`} className={`max-[500px]:text-sm ${styles.cardFieldLabel}`}>
          Block hash
        </label>
        <div className="flex gap-2 justify-center w-full">
          {data?.blockHash ? (
            <a
              id={`blockHash-${data?.blockHash + "_" + data?.topic}`}
              href={getExplorerBlockUrl(data.blockHash)}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.cardField} text-[#4747e3]`}
            >
              {data.blockHash}
            </a>
          ) : (
            <span id={`blockHash-${data?.blockHash + "_" + data?.topic}`} className={styles.cardField} />
          )}
          <Tooltip title={isCopied ? "Copied!" : "Copy text!"}>
            <button onClick={() => copyToClipboard(data?.blockHash)}>
              <img src={require("../images/copy-icon.png")} alt="Copy to Clipboard"></img>
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <label htmlFor={`transactionHash-${data.id}`} className={`max-[500px]:text-sm ${styles.cardFieldLabel}`}>
          Transaction hash
        </label>
        <div className="flex gap-2 justify-center w-full">
          {data?.transactionHash ? (
            <a
              id={`transactionHash-${data?.transactionHash + "_" + data?.topic}`}
              href={getExplorerTxUrl(data.transactionHash)}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.cardField} text-[#4747e3]`}
            >
              {data.transactionHash}
            </a>
          ) : (
            <span id={`transactionHash-${data?.transactionHash + "_" + data?.topic}`} className={styles.cardField} />
          )}
          <Tooltip title={isCopied ? "Copied!" : "Copy text!"}>
            <button onClick={() => copyToClipboard(data?.transactionHash)}>
              <img src={require("../images/copy-icon.png")} alt="Copy to Clipboard"></img>
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <label htmlFor={`trustedIssuer-${data.id}`} className={`max-[500px]:text-sm ${styles.cardFieldLabel}`}>
          Trusted Issuer Wallet
        </label>
        <div className="flex gap-2 justify-center w-full">
          <input
            type="text"
            id={`trustedIssuer-${data?.trustedIssuer + "_" + data?.topic}`}
            name={`trustedIssuer-${data.id}`}
            className={styles.cardField}
            value={data?.trustedIssuer || ""}
            readOnly
          ></input>
          <Tooltip title={isCopied ? "Copied!" : "Copy text!"}>
            <button onClick={() => copyToClipboard(data?.trustedIssuer)}>
              <img src={require("../images/copy-icon.png")} alt="Copy to Clipboard"></img>
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <p className="max-[500px]:text-sm">Trusted Issuer Email</p>
        <div className="flex gap-2 justify-center">
          <p className="max-[500px]:text-xs">{data?.trustedIssuerEmail || "N/A"}</p>
        </div>
      </div>
    </div>
  );
};
